import React from 'react';
import {useField} from 'formik';
import AccessibleTypeahead from 'shared/components/accessible-typeahead';

/**
  For use in Formik forms.

  Usage example:
  <FormikTypeahead name="collegeName" options={options} onSelect={handleSelect} />
*/

// TODO: Replace $TSFixMe with AccessibleTypeahead props once converted to TS
const FormikTypeahead = (props: {name: string} & $TSFixMe) => {
  const [field, meta, helpers] = useField({name: props.name, type: 'text'});
  return (
    <AccessibleTypeahead
      {...props}
      {...field}
      error={meta.touched ? meta.error : ''}
      onInputChange={(value) => {
        const text = typeof value === 'string' ? value : value.text;
        helpers.setValue(text);
      }}
    />
  );
};

export default FormikTypeahead;
